import * as React from "react";

import { DevPageComp } from "../Components/DevPageComp";

// markup
const DevPage = (props) => {
  return <DevPageComp  props={props}/>;
};

export default DevPage;
